import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { ButtonModule, ButtonOptions } from '@usitsdasdesign/dds-ng/button';
import { ExtThemes, ButtonKind, Size, WidthState, TabThemeType, Themes } from '@usitsdasdesign/dds-ng/shared';
import { TabComponent, TabOptions, TabsModule, TabsOptions } from '@usitsdasdesign/dds-ng/tabs';
import 'brace';

import 'brace/mode/text';
import 'brace/mode/xml';
import 'brace/mode/yaml';
import 'brace/theme/github';
import 'brace/theme/clouds';
import 'brace/mode/javascript';

import { ProjectsService } from '../core/services/projects.service';
import { Project } from '../core/models/project.models';
import { ApiSpecificationsComponent } from './api-specifications/api-specifications.component';
import { ProjectServicesComponent } from './project-services/project-services.component';
import { ProjectTeamComponent } from './project-team/project-team.component';
import { CommonModule, DatePipe } from '@angular/common';

@Component({
  selector: 'app-project-details',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    TabsModule,
    RouterOutlet,
    ApiSpecificationsComponent,
    ProjectServicesComponent,
    ProjectTeamComponent,
  ],
  templateUrl: './project-details.component.html',
  styleUrl: './project-details.component.scss',
})
export class ProjectDetailsComponent {
  projectId: string;
  project: Project | null;
  activeTabIndex: number = 0;

  constructor(private route: ActivatedRoute, private router: Router, private projectService: ProjectsService) {}

  editButtonOptions: ButtonOptions = {
    theme: ExtThemes.green,
    kind: ButtonKind.primary,
    size: Size.md,
    width: WidthState.fixed,
    isLoading: false,
    icon: 'dds-icon_edit',
    isIconLeft: false,
    isColorBg: false,
    isInverse: false,
    disabled: false,
    ariaLabel: 'Edit project',
    customClass: '',
    role: 'button',
  };

  editProjectClick(): void {
    this.router.navigate(['project-edit', this.projectId]);
  }

  tabContainerOptions: TabsOptions = {
    theme: Themes.green,
    themeType: TabThemeType.border,
    size: Size.lg,
    ariaLabel: 'Horizontal tabs',
    disabled: false,
    isInverse: false,
    customClass: '',
    isResponsive: false,
    activeIndex: this.activeTabIndex, // doesn't seem to work to dynamically set the active tab
  };

  tabOptions1: TabOptions = {
    label: 'API Specification',
    icon: 'dds-icon_code__s__stroke',
  };
  tabOptions2: TabOptions = {
    label: 'Services',
    icon: 'dds-icon_service__l__stroke',
  };
  tabOptions3: TabOptions = {
    label: 'Team',
    icon: 'dds-icon_users__l__stroke',
  };

  tabChanged(tabItem: TabComponent) {
    switch (tabItem.label) {
      case 'API Specification':
        this.router.navigate(['api-specifications'], { relativeTo: this.route });
        break;
      case 'Services':
        this.router.navigate(['services'], { relativeTo: this.route });
        break;
      case 'Team':
        this.router.navigate(['team'], { relativeTo: this.route });
        break;
    }
  }

  setActiveTab(currentPath: string): void {
    switch (currentPath) {
      case 'api-specifications':
        this.activeTabIndex = 0;
        this.tabOptions1.isActive = true;
        break;
      case 'services':
        this.activeTabIndex = 1;
        this.tabOptions2.isActive = true;
        break;
      case 'team':
        this.activeTabIndex = 2;
        this.tabOptions3.isActive = true;
        break;
      default:
        this.activeTabIndex = 0;
        this.tabOptions1.isActive = true;
    }
    console.log(`ActiveTabIndex: ${this.activeTabIndex}`); // logic to dynamically set the active tab seem to work, but dds component doesn't update it
  }

  ngOnInit(): void {
    this.project = null;
    this.activeTabIndex = 0;

    this.route.paramMap.subscribe((params) => {
      let currentPath = this.route.snapshot.firstChild?.url[0].path;
      this.setActiveTab(currentPath ?? '');
      this.projectId = params.get('id') ?? '';
      this.projectService.getProjectById(this.projectId).subscribe((response) => {
        this.project = response;
      });
    });
  }
}
